

    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import Utils from "@/utilities/Utils";

    @Component({ })
    export default class PrintTextArea extends Vue {

        @Prop({ default: null }) value!: string;

        @Prop({ default: 3 }) rows!: number;

        onTextInput(event: Event) {
            //const textarea = event.target as HTMLTextAreaElement;
            //const h = Math.max(textarea.scrollHeight, this.rows * 28);
//console.log(`+++ Scroll height: ${textarea.scrollHeight} | rows:${this.rows} | h:${h}`);
            //textarea.style.height = `${h}px`;
            this.$emit("input", (event.target as HTMLInputElement)?.value);
        }

        get hasValue(): boolean {
            return !Utils.isEmptyOrWhitespace(this.value);
        }
    }
